'use client';

import classNames from '@sindresorhus/class-names';
import {SwitchLanguage} from '@ui-kit/src';
import {usePathname} from 'next/navigation';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {isFirstLevelDomain} from '@web-landing/utils/showLocalization';

import styles from './SwitchLanguageComponent.module.scss';

export const SwitchLanguageComponent = ({
  showLocalization,
  location,
}: {
  showLocalization: boolean;
  location: 'header' | 'footer';
}) => {
  const route = usePathname();

  if (showLocalization && isFirstLevelDomain(route)) {
    return (
      <div className={classNames({[styles.withMargin]: location === 'footer'})}>
        <SwitchLanguage
          isHeader={location === 'header'}
          logTmrEvent={logTmrEvent}
        />
      </div>
    );
  }
};
